<template>
  <Transition>
    <PopUpLight 
      v-if="open"
      @closed="emitClose"
    >
      <div class="flex flex-col items-center text-center p-6 gap-4">

        <h2 class="text-2xl font-semibold mb-3">
          {{
            sendOk
              ? $t("send_ok_title")
              : hasPhone
                ? $t("verify_phone_title")
                : $t("add_phone_title")
          }}
        </h2>

        <p class="text-sm">
          {{
            sendOk
              ? $t("send_ok_description")
              : hasPhone
                ? $t("verify_phone_description")
                : $t("add_phone_description")
          }}
        </p>

        <div v-if="!sendOk" class="w-full flex justify-center mb-6">
          <InputPhone 
            :initialPhone="initialPhone"
            :initialPrefix="initialPrefix"
            @phoneValidated="handlePhoneValidated" 
          />
        </div>

        <button 
          v-disable-on-click:verify-phone
          :disabled="isDisabled"
          :class="{ forceDisabled: isDisabled }"
          class="w-full max-w-xs h-12 search-btn sm:flex sm:justify-center sm:items-center"
          @click="verifyPhone()"
        >
          {{
            sendOk
              ? $t("send_ok_button")
              : hasPhone
                ? $t("verify_phone_button")
                : $t("add_phone_button")
          }}
        </button>

        <button v-if="!sendOk" class="w-full max-w-xs h-12 search-btn sm:flex sm:justify-center sm:items-center"
          @click="anotherTime()"
        >
          {{ $t("another_time")}}
        </button>

        <a v-if="!sendOk && showRemain" href="#" class="text-sm text-[#0458E2] no-underline"
          @click.prevent="notRemind()"
        >
          {{ $t("not_remind")}}
        </a>
      </div>
    </PopUpLight>
  </Transition>
</template>


<script lang="ts">
import { defineComponent } from 'vue';
import InputPhone from "@/components/form/inputPhone.vue";
import PopUpLight from "@/components/popup/popupLight.vue";
import CustomerHelper from '@/helpers/customerHelper';
import { customGlobalError } from '@/helpers/errorHelper';
import { Format } from '@/helpers/formatHelper';
import LocalStorage from '@/helpers/localStorage';

export default defineComponent({
  name: 'VerifyAndAddPhone',
  components: {
    InputPhone,
    PopUpLight,
  },
  emits: {
    newPhone(prefix: string, value: string) {
      return (typeof prefix === "string" || typeof prefix === "number")
        && typeof value === "string";
    },
    close(){
      return true;
    }
  },
  props: {
    initialPhone: String,
    initialPrefix: String,
    open: {
      type: Boolean,
      required: true,
    },
    hasPhone: {
      type: Boolean,
      required: true,
    },
    showRemain: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      phone: this.initialPhone as string,
      prefix: this.initialPrefix as string,
      sendOk: false as boolean,
      expiry:  new Date(new Date().getTime() + 15 * 24 * 60 * 60 * 1000)
    };
  },
  computed: {
    hasErrors(): boolean {
      return Format.IsNull(this.phone) || Format.IsNull(this.prefix);
    },
    isDisabled(): boolean {
      return !this.sendOk && this.hasErrors;
    },
  },
  watch: {
    open(val) {
      if (val) this.sendOk = false;
    }
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    handlePhoneValidated(phone: string, prefix: string) {
      this.phone = phone;
      this.prefix = prefix
    },
    async verifyPhone(){
      if(this.sendOk) return this.emitClose()
      if(this.hasErrors){
        // release the button that v-disable-on-click just blocked
        window.dispatchEvent(new Event('verify-phone'));
        return
      }
      try {
        const response = await CustomerHelper.updatePhone(this.prefix, this.phone)
        if(response?.id){
          this.$emit("newPhone", this.prefix, this.phone)
          this.sendOk = true;
          LocalStorage.addWithTimout("not_remind", "not_remind", this.expiry);
        } else {
          customGlobalError(this.$t("sorry_we_are_having_problems_please_try_again_later"));
        }
      } catch {
        // the axios interceptor already opened the global error popup
      } finally {
        window.dispatchEvent(new Event('verify-phone'));
      }
    },
    anotherTime(){
      LocalStorage.addWithTimout("not_remind", "not_remind", this.expiry);
      this.$emit("close");
    },
    notRemind(){
      LocalStorage.add("not_remind", "not_remind");
      this.$emit("close");
    }
  },
});
</script>